import React from 'react';
import { FilterOption } from '../../../types';
import {
  ActiveOptionContainer,
  ActiveListWrapper,
  CancellButton,
} from './ModelFamilySelector.style';
import CancelIcon from '../../../assets/icons/CancelIcon';
import CheckboxSelector from '../../CheckboxComponent';

interface ActiveModelsProps {
  modelFamilyOptions: {
    [key: string]: FilterOption;
  };
  selectedModelFamilyFilters: string[];
  onChange: (newValue: string) => void;
}

const ActiveModelFamiliesList: React.FC<ActiveModelsProps> = ({
  modelFamilyOptions,
  selectedModelFamilyFilters,
  onChange,
}) => {
  return (
    <ActiveListWrapper>
      {selectedModelFamilyFilters.map((item) => {
        const model = modelFamilyOptions[item];
        return (
          <ActiveOptionContainer key={`model-family-active-${model.value}`}>
            <CheckboxSelector
              inputName={`active-${model.value}`}
              onChange={() => onChange(model.value)}
              value={model.value}
              label={model.label}
              ariaLabel={model.ariaLabel}
              checked={selectedModelFamilyFilters.includes(model.value)}
              disabled={model.disabled}
            />
            <CancellButton onClick={() => onChange(model.value)}>
              <CancelIcon />
            </CancellButton>
          </ActiveOptionContainer>
        );
      })}
    </ActiveListWrapper>
  );
};

export default ActiveModelFamiliesList;
